(function () {
  const openButton = document.getElementById('enquire-now-btn');
  const closeButton = document.getElementById('enquire-now-close-btn');
  const content = document.getElementById('enquire-now-drawer');
  const form = document.querySelector('form#enquire-now-form');

  openButton.addEventListener('click', () => {
      content.classList.add('active');
  });
  
   closeButton.addEventListener('click', () => {
      content.classList.remove('no-animation')
      content.classList.remove('active');
  });

  var url = new URL(window.location.href);
  var paramValue = url.searchParams.get('contact_posted');
  if (paramValue) {
    content.classList.add('no-animation')
    content.classList.add('active');
  }
})()